<template>
  <h1><span class="text-primary">Условия использования</span> веб-сайта {{ $domain }}</h1>
  <AppThirdLayout>
    <h2>Преамбула</h2>
    <div>
      <p class="mb-2">Сайт <AppLink :to="hostUrl">"{{ $domain }}"</AppLink>,
        (далее "Сайт") управляется компанией ИП Кривда Иван Викторович ИНН: {{ $branch.business.number }} (далее "Оператор") и
        предлагает услуги по электронному оформлению виз и получению визовых одобрений для различных стран. Вы можете
        воспользоваться услугами при условии вашего согласия с условиями использования, которые будут подробно изложены ниже.
        Если вы не согласны с положениями сайта – полностью или частично – вам запрещается использовать этот сайт для любых
        целей.</p>
      <p class="mb-2">Кроме того, использование этого сайта, его содержания и предлагаемых услуг, загрузки файлов, медиа, таких как
        изображения и видео, а также других различных материалов, доступных посетителям, может изменяться время от времени или
        в зависимости от типа контента.</p>
      <p>Администрация сайта оставляет за собой право обновлять условия использования, изложенные ниже, время от времени и без
        предварительного уведомления или специального объявления на различных каналах сайта.</p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Интеллектуальная собственность</h2>
    <div>
      <p class="mb-2">Сайт, а также вся информация на нем, включая дизайн сайта, его код, медиафайлы, включая графику, видео, изображения,
        тексты, файлы для загрузки и любой другой материал, представленный на сайте, полностью принадлежат упомянутому сайту и
        являются исключительной интеллектуальной собственностью сайта "{{ $domain }}". Их использование без предварительного
        письменного разрешения от сайта "{{ $domain }}" запрещено.</p>
      <p>Кроме того, запрещается распространять, копировать, воспроизводить, публиковать, имитировать или обрабатывать
        фрагменты кода, графику, видео, товарные знаки или любые другие медиа и контент без письменного разрешения от
        администрации сайта.</p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Содержание сайта</h2>
    <div>
      <p class="mb-2">Мы стремимся предоставлять вам информацию, представленную на сайте, без помех, однако могут возникнуть проблемы из-за
        технических соображений сбоев и других причин, мешающих доступности сайта. Поэтому мы не можем гарантировать, что сайт
        будет доступен в любое время, и не предоставляем никакой компенсации за прерывание сервиса/удаление сайта.</p>
      <p class="mb-2">Ссылки на внешние сайты не гарантируют, что это безопасные, качественные или надежные сайты, и посещение их
        осуществляется исключительно на ваш собственный риск и является исключительной ответственностью пользователя сайта.
      </p>
      <p>Контент, предложенный на сайте, является исключительной собственностью "{{ $domain }}", и его использование,
        противоречащее
        положениям настоящего регламента, запрещено, за исключением случаев, когда указано иначе или когда указано, что
        авторские права принадлежат внешнему органу. В таких случаях следует проверять условия использования по прилагаемой
        ссылке и действовать в соответствии с указаниями на внешнем сайте.</p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Управление пользователями и посетителями сайта</h2>
    <div>
      <p class="mb-2">Администрация сайта оставляет за собой право блокировать любого пользователя, будь то путем блокирования IP-адреса
        его компьютера, MAC-адреса его компьютера или даже в соответствии со страной происхождения, без необходимости
        предоставления объяснения для посетителя.</p>
      <p class="mb-2">Администрация сайта сайта сделает все возможное, чтобы защитить личные данные пользователей сайта. В случаях, когда
        третья сторона получает доступ к информации, включая данные паспорта, соглашается, что у посетителей, клиентов и
        пользователей сайта не будет никаких исков, претензий или требований к оператору и/или команде сайта "{{ $domain }}".
      </p>
      <p class="mb-2">Ввод данных кредитной карты считается вашим согласием на использование карты для оплаты услуг.</p>
      <p>Оператор не обязуется хранить и резервировать введенную на сайте информацию и не несет ответственности за потерю
        информации.</p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Откровенное признание</h2>
    <p>На этом сайте могут использоваться файлы cookie (особенно для зарегистрированных и подписанных пользователей) и
      внутренние статистические интерфейсы для сохранения анонимной статистической документации посетителей и анализа
      трафика посетителей/пользователей, привычек просмотра на сайте и анализа кликов и времени пребывания. В любое время,
      кроме как для зарегистрированных пользователей, сохраняемая информация полностью анонимна и не содержит имени
      пользователя или любых других идентифицирующих данных.</p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Надлежащее использование</h2>
    <p>Вы должны соблюдать все политики и руководства, представленные на сайте и на странице, которую вы используете. Вы
      соглашаетесь не использовать сайт ненадлежащим образом - например, использовать внешние средства и методы, которые не
      являются частью интерфейса сайта. Вы можете использовать сайт только в соответствии с законом и согласно инструкциям,
      которые мы предоставляем на сайте. Любое нарушение может привести к отказу в предоставлении услуг со стороны команды
      сайта. Отмечается, что информация, которую вы вводите на сайте, будет обработана и отправлена в соответствующее
      правительственное учреждение для оформления визы, поэтому предоставление ложной информации на сайте является уголовным
      преступлением, а любое ложное или вводящее в заблуждение заявление может привести к отказу в визе и/или постоянному
      запрету на въезд в страны.</p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Описание услуги</h2>
    <div>
      <p class="mb-2">Сайт предлагает услугу оформления виз в различные страны за плату. Это единственная и исключительная услуга,
        предлагаемая сайтом и его командой.</p>
      <p>Вы принимаете, что команда сайта не несет ответственности за сроки оформления и отправки визы клиенту. Получение визы
        раньше или позже указанной даты не является основанием для возврата денег или предъявления иска, так как услуга
        заключается только в оформлении визы. Никаких обязательств по соблюдению графика клиента не предусмотрено.</p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Право отказа в обслуживании</h2>
    <p>Сайт и его команда оставляют за собой право выбирать, кому оказывать услуги, а кому нет. Сайт и его команда имеют
      право отказать в обслуживании любому лицу без объяснения причин.</p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Ответственность за использование</h2>
    <div>
      <p class="mb-2">В случае отказа в предоставлении визы и/или запрета на въезд в страну - временно или постоянно - сайт и его команда
        не несут ответственности. Вы принимаете последствия использования услуг сайта и соглашаетесь нести полную
        ответственность во всех вышеуказанных случаях и не будете иметь претензий к оператору и команде сайта. Оператор
        освобождается от ответственности за любые сбои, неточности, опечатки или печатные ошибки при вводе данных
        пользователем на сайте. Пользователь не имеет права предъявлять претензии к владельцу сайта за ущерб или потери,
        возможно возникшие из-за таких сбоев и ошибок.</p>
      <ol>
        <li>Используя сайт, вы обязуетесь не делать одно или несколько из следующих действий:</li>
        <li>Подделка личности или организации, предоставление ложных сведений</li>
        <li>Отправка любого ложного и вводящего в заблуждение материала или материала, предназначенного для обмана любого лица
          или организации, непосредственно или косвенно.</li>
        <li>Отправка любого материала, содержащего какой-либо тип компьютерного вируса или любой другой компьютерный код,
          предназначенный для разрушения, нарушения или ограничения использования (включая любое использование, кроме
          справедливого и разумного использования услуги) любого из компьютеров, серверов, оборудования и/или программного
          обеспечения, используемых компанией для предоставления услуг, предлагаемых на этом сайте.</li>
        <li>Распространение "спама" на сервера сайта или их переполнение любым другим почтовым сообщением.</li>
        <li>Изменение, обработка, копирование, извлечение данных, адаптация, предоставление сублицензии, перевод, продажа,
          выполнение действий обратной инженерии, разборка или повторная сборка любой части кода, составляющего сайт, включая
          базу данных, а также такие действия в отношении оборудования и программного обеспечения, используемого для
          предоставления услуги.</li>
        <li>Размещение сайта или любой его части в рамках другого сайта (frame) или как часть другого сайта (mirror) без
          письменного согласия компании.</li>
        <li>Использование любого "робота", "паука" (spider), поискового и извлекающего движка, или любого другого
          автоматического или ручного инструмента, предназначенного для индексации, извлечения и обнаружения информации на
          сайте или инструмента, предназначенного для раскрытия структуры базы данных и кода на этом сайте.</li>
        <li>Любое другое вмешательство или прерывание работы сайта (включая вмешательство в работу серверов и компьютерной
          сети, подключенной к сайту или сети, подключенной к ней) или нарушение требований и процедур сайта любым другим
          способом.</li>
        <li>Сбор или хранение личной информации о других пользователях в экономических или незаконных целях. А также продажа,
          распространение или любое экономическое использование информации на сайте или любое другое использование, которое
          может нанести ущерб человеку, для которого информация является релевантной.</li>
        <li>Право на обработку и перевод текста- Вы понимаете и соглашаетесь с тем, что в рамках усилий команды сайта по
          предоставлению быстрого и удобного обслуживания своим клиентам, информация, введенная в формы сайта, будет
          переведена и/или обработана текстово, по усмотрению команды сайта. Перевод и обработка выполняются для того, чтобы
          соответствовать запросам клиентов на сайте требованиям различных ведомств, через которые команда сайта оформляет
          въездные визы. Вы подтверждаете и предоставляете команде сайта свободу в переводе и обработке содержимого, которое
          вы вводите на сайте.</li>
      </ol>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Срочная обработка заказа</h2>
    <p>
      Для ускоренной обработки заказа вы можете доплатить дополнительный сбор. Обратите внимание, что выбор этого варианта
      не гарантирует одобрение вашей заявки в указанные сроки (например, в течение одного дня). Этот вариант обеспечивает
      приоритетную обработку вашей заявки нашей командой, что значительно увеличивает вероятность ускоренного одобрения. В
      случае, если мы не сможем получить одобрение в желаемые сроки, дополнительный сбор за срочную обработку будет
      возвращен.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Срок обработки</h2>
    <p>Заявления на сайте о времени от использования его услуг до оформления визы и ее отправки клиенту являются только
      разумными оценками команды сайта на основе предыдущего опыта предоставления такой услуги. Эти заявления не должны
      рассматриваться как обязательство по скорости или времени выполнения услуги, так как это зависит от факторов, не
      подконтрольных сайту и его команде, таких как процедуры иммиграционных властей и иностранных министерств иностранных
      дел, праздники, периодические нагрузки и т.д. Вы осведомлены и соглашаетесь с тем, что сроки услуги могут быть
      укорочены или продлены из-за ожидаемых и неожиданных факторов.</p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Средства коммуникации</h2>
    <p>Все взаимодействия сайта и его команды с клиентом осуществляются посредством электронной почты (e-mail). Вы понимаете
      и осознаете, что любая попытка связаться с вами, будь то для отправки визы или по любой другой причине, будет
      осуществляться через сообщение электронной почты, отправленное на адрес электронной почты, который вы указали в форме
      на нашем сайте. Команда сайта может отправлять, в том числе, замечания и предупреждения по поводу данных, которые вы
      ввели в формах на сайте. Вы понимаете, что обязаны регулярно проверять почтовый ящик электронной почты, который вы
      указали на сайте, для получения обновлений, сообщений и запросов от сайта и его команды. Это относится также к
      сообщениям, которые были перенаправлены в папку спам (Spam) по какой-либо причине. Команда сайта не несет
      ответственности в случае вашего незнания о сообщениях, которые были отправлены - даже в случаях, когда команда сайта
      приостановила обработку вашего запроса до получения соответствующего ответа от вас по электронной почте.</p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Проверка данных</h2>
    <p>Вы осознаете и понимаете, что ответственность за проверку правильности информации, отправленной вами на сайт, и
      ответственность за проверку правильности информации, отправленной командой сайта вам, лежит исключительно на вас. Вы
      понимаете, что обязаны проверять правильность данных (включая имена, номера паспортов, даты, и т.п.) с момента
      получения визы - или любого другого сообщения от сайта или его команды - в ваш почтовый ящик. Вы понимаете, что
      обязаны регулярно проверять ваш почтовый ящик, в том числе для подготовки к непредвиденным обстоятельствам, таким как
      ошибка в данных визы. В случае ошибки в данных визы - будь то вызвано системой сайта или его командой, или же вызвано
      вами или каким-либо третьим лицом - ваша исключительная обязанность немедленно сообщить об этом команде сайта по
      электронной почте. Сайт и его команда не несут ответственности за любые финансовые потери и/или моральный ущерб,
      возникшие в результате позднего сообщения (то есть, после момента, когда стало возможным своевременное исправление и
      обработка проблемы) или непредоставления сообщения об ошибке в визе и/или в сообщении, отправленном системой сайта.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Информация на сайте</h2>
    <p>Вы хорошо понимаете, что информация, представленная на сайте, и информация, предоставленная командой сайта, не
      поступает от официального источника. Вы осознаете, что предоставленная сайтом и командой информация по вопросам, не
      связанным напрямую с одобрением визы (например, рейсы, процедуры в портах, авиакомпании, соблюдение законов и т.д.),
      является лишь рекомендацией и может быть неверной или неподходящей. У вас не будет никаких претензий, если окажется,
      что информация, представленная на сайте и предоставленная командой сайта, не точна и/или неверна. Вся информация,
      предоставленная сайтом и его командой, предназначена исключительно для помощи клиентам компании на основе знаний
      команды. Это не гарантирует точности данных и информации.</p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Политика отмены</h2>
    <p>При отправке формы на одной из страниц сайта, системы сайта работают автоматически, чтобы быстро ответить клиентам
      сайта. Эти действия включают в себя, среди прочего, оплату сборов за визы государственным иммиграционным органам и
      другим соответствующим сторонам, помогающим команде сайта выдавать визы. С момента отправки любой формы на сайте и
      оплаты, денежные возвраты за отмену заказа не предусмотрены. Команда сайта вправе отказать в любом запросе на возврат
      денег за отмену заказа в любых обстоятельствах.</p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Возврат денег</h2>
    <div>
      <p class="mb-2">В рамках электронного оформления виз, команда сайта предлагает полный возврат денег в случаях, когда ваша заявка на
        визу отклонена по вине команды нашего сайта, или если выдача визы и ее отправка задерживаются более чем на 7 рабочих
        дней по вине команды сайта.</p>
      <p class="mb-2">Однако существуют ограничения, исключающие этот возврат денег и освобождающие сайт и его команду от этой обязанности:
        любой отказ в заявке на визу или отказ в утверждении визы из-за неправильных и/или неточных и/или неактуальных и/или
        отсутствующих данных, введенных вами в одну из форм сайта, или предоставленных команде сайта любым из предложенных на
        сайте способов связи. Это также относится к информации, предоставленной команде сайта с опозданием, в ситуациях, когда
        иммиграционные власти требуют дополнительную информацию для выдачи визы и устанавливают максимальный срок для
        получения ответа. Дополнительные исключения, освобождающие сайт от возврата денег из-за отказа, включают отказ из-за
        форс-мажорных обстоятельств , находящихся вне нашего контроля, например, экстремальные погодные условия, приводящие к
        отмене рейсов, или мировая пандемия, такая как коронавирус, приводящая к закрытию границ. Кроме того, если вы ранее
        подавали аналогичное заявление в ту же страну и оно было отклонено, или если заявка была одобрена и виза все еще
        действительна.</p>
      <p>Любое использование сайта, нарушающее одно или несколько из условий, указанных на этой странице лишит пользователя
        права на возврат денег.</p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Сборы за отмену транзакции</h2>
    <p>Вы осведомлены и согласны с тем, что в случае отмены компанией транзакции, которую вы совершили с ней, включая любую
      покупку и/или оплату, компания имеет право взимать с вас сбор за отмену транзакции (10% от суммы отмены), включая
      комиссионные и/или сборы за сбор, уплаченные поставщикам платежных решений, интегрированным компанией на сайте.</p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Компенсации</h2>
    <div>
      <p class="mb-2">Вы осведомлены и полностью понимаете, что сайт и его команда предоставляют только услуги по оформлению виз. То есть,
        конечный продукт, за который платит клиент и который он получает, это подтверждение визы в конкретную страну, и ничего
        больше. Следовательно, компания не обязана компенсировать суммы, превышающие стоимость услуг сайта, которую вы
        оплатили. Компания не несет финансовой ответственности за действия, которые вы совершили в результате использования
        услуг сайта - такие как бронирование полета, места проживания, изменение заказа и т.д. Кроме того, компания не обязана
        компенсировать моральный ущерб, даже если он был вызван неправильным поведением команды сайта.</p>
      <p>Компания и ее команда не несут ответственности в случае, если государственный орган запрещает вам или любому другому
        клиенту въезд в любую страну, временно или постоянно. Это также относится к ситуациям, когда государственный орган
        запрещает вам или любому другому клиенту выдачу виз в любую страну, временно или постоянно.</p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Ущерб</h2>
    <p>Вы обязуетесь возместить оператору, или его представителям, любые иски, требования, убытки, потери, упущенную выгоду,
      платежи или любые расходы, понесенные ими – включая разумные гонорары адвокатов и судебные издержки – в результате
      нарушения вами этого регламента и/или закона и/или требования третьей стороны и/или любого нарушения условий сайта.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Изменения условий использования</h2>
    <p>Условия использования сайта могут изменяться в любое время и без предварительного уведомления, в соответствии с
      желанием команды сайта. Система сайта и его команда не обязаны уведомлять о любых изменениях условий использования.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Политика конфиденциальности</h2>
    <p>Используя сайт, вы соглашаетесь с политикой конфиденциальности сайта.</p>
  </AppThirdLayout>
</template>

<script setup lang="ts">
const { hostUrl } = useRouting();
</script>